import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ROUTE_CONSTANT } from "../../routing/route-constants";
import AppButton from "../../components/button/component";
import AppTextField from "../../components/text-field/component";
import Header from "../../components/header";
import Loader from "../../components/loader";
import { validateEmail, validatePassword } from "../../utils/validation";
import { toast } from "react-toastify";
import Footer from "../../components/footer";
import { getCookie } from "../../utils/utility-functions";

function AdminLogin({
  loginUserAndAuthenticateConnect,
  isAdminUserConnect,
  funnelStep,
}) {
  const { isAuth } = funnelStep;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  // const token = getCookie("jwtToken");
  const token = isAuth === true;
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState({
    emailError: "",
    passwordError: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let error = "";
    if (name === "email") {
      error = validateEmail(value);
    } else if (name === "password") {
      error = validatePassword(value);
    }
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
    setError((prevError) => ({ ...prevError, [`${name}Error`]: error }));
  };
  const handleSignin = (event) => {
    event.preventDefault();
    const { email, password } = formData;
    const isEmailError = validateEmail(email.trim());
    const isPwdError = validatePassword(password.trim());
    if (isEmailError.length > 0) {
      setError((prevError) => ({ ...prevError, emailError: isEmailError }));
    } else {
      setError((prevError) => ({ ...prevError, emailError: "" }));
    }
    if (isPwdError.length > 0) {
      setError((prevError) => ({ ...prevError, passwordError: isPwdError }));
    } else {
      setError((prevError) => ({ ...prevError, passwordError: "" }));
    }
    if (isEmailError.length > 0 || isPwdError.length > 0) return;

    const params = {
      Username: email.trim(),
      Password: password.trim(),
    };
    let userDetails = {
      adminUserName: email,
    };
    setIsLoading(true);
    isAdminUserConnect(userDetails)
      .then((res) => {
        if (!!res) {
          // If the user is an admin, proceed to the next step
          return loginUserAndAuthenticateConnect(params);
        } else {
          // Show error and prevent further actions
          toast.error("Shoot!! You do not have access.");
          throw new Error("User is not an admin.");
        }
      })
      .then((response) => {
        if (!!response) {
          navigate(ROUTE_CONSTANT.ADMIN_SEARCH);
        } else {
          toast.error("Login failed!");
        }
      })
      .catch((error) => {
        console.error("Sign-in failed", error);
      })
      .finally(() => {
        setIsLoading(false); // Stop loader
      });
  };
  useEffect(() => {
    if (token) {
      navigate(ROUTE_CONSTANT.ADMIN_SEARCH);
    }
  }, [token]);
  return (
    <div>
      <Header />
      <div className="p-5 text-center bg-white flex-grow flex flex-col justify-center items-center">
        <h1 className="font-bold color-[#444C5E] text-4xl mb-4">Login</h1>
        <Loader isLoading={isLoading} />
        <div className="flex justify-center mt-8 w-full max-w-xs">
          <form className="space-y-4 w-full max-w-xs" onSubmit={handleSignin}>
            <AppTextField
              label="Email"
              name="email"
              onChange={handleInputChange}
              value={formData.email}
              error={error.emailError}
              placeholder="Enter your email"
              // readOnly={emailAddress ? true : false}
            />
            <AppTextField
              label="Password"
              name="password"
              onChange={handleInputChange}
              value={formData.password}
              error={error.passwordError}
              type="password"
              placeholder="Enter your password"
            />

            <AppButton
              type="submit"
              className="bg-[#FE6634] hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 text-white"
            >
              Log In
            </AppButton>
          </form>
        </div>
      </div>
      <Footer className="fixed" />
    </div>
  );
}

export default AdminLogin;
